module.exports = __webpack_public_path__ + "img/user_d.e7d8e097.svg";